import React, { FC, useEffect, useState } from "react";
import { Hidden, Link, Typography } from "@insite/mobius/index";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import Radio from "@insite/mobius/Radio";
import Icon from "@insite/mobius/Icon";
import Button from "@insite/mobius/Button";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import styled from "styled-components";
import { getProp } from "@insite/mobius/utilities";
import {
    CreditCardDtoCollection,
    getSavedCreditCards,
    GetSavedCreditCardsModel,
} from "@NA/Services/SavedCreditCardsService";
import ADIColors from "@NA/Utils/ADIColors";
import translate from "@insite/client-framework/Translate";
import ADINewCreditCardModalRecap from "@NA/Components/MyAccountRecapPayment/ADINewCreditCardModalRecap";
import ADIEditCreditCardModalRecap from "@NA/Components/MyAccountRecapPayment/ADIEditCreditCardModalRecap";
import ADIDeleteCreditCardModalRecap from "@NA/Components/MyAccountRecapPayment/ADIDeleteCreditCardModalRecap";
import NpWarning from "@NA/Icons/NpWarning";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import ADINewCreditCardModalPopup from "@NA/Components/SaveCard/ADINewCreditCardModalPopup";

export interface InvoiceHeaderTabsStyles {
    centeringWrapper?: InjectableCss;
    container?: InjectableCss;
    tabs?: InjectableCss;
    noDataFound?: InjectableCss;
    newCard?: InjectableCss;
    addNewTitle?: InjectableCss;
    tableHeaderWrapper?: InjectableCss;
    button?: InjectableCss;
    footerButtonWrapper?: InjectableCss;
    cancelButton?: InjectableCss;
    cardExpired?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    radioListGroup?: RadioGroupProps;
    creditCardHeaderContainer?: InjectableCss;
    selectColumn?: InjectableCss;
    cardDetailsColumn?: InjectableCss;
    cardExpiryColumn?: InjectableCss;
    editDeleteColumn?: InjectableCss;
    accountNumberColumn?: InjectableCss;
    creditCardDataContainer?: InjectableCss;
    bankAccountContainerForMobile?: InjectableCss;
    selectColumnForMobile?: InjectableCss;
    creditCardDataContainerForMobile?: InjectableCss;
    sectionWrapper?: InjectableCss;
}

export const tableStyles: InvoiceHeaderTabsStyles = {

    tabs: {
        css: css`
            padding: 7px 30px;
            border-radius: 6px;
            border: 0;
            background-color: ${ADIColors.white};
            text-align: center;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            line-height: 22px;
            font-weight: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all 0.1s ease;
            position: relative;
            overflow: visible;

            &:nth-of-type(2) {
                margin-left: 10px;
            }

            &::after {
                content: "";
                width: 3px;
                height: 22px;
                margin: 6px 0 6px 1px;
                border-radius: 1px;
                background-color: ${ADIColors.gray2};
                position: absolute;
                right: -6px;
                z-index: 10;
            }

            &:last-child::after {
                display: none;
            }

            &.active {
                background-color: ${ADIColors.darkBlue1};
                color: ${ADIColors.white};
                font-weight: 600;
            }
        `,
    },

    addNewTitle: {
        css: css`
            font-weight: 700;
            color: ${ADIColors.blue5};
        `
    },
    tableHeaderWrapper: {
        css: css`
            background-color: ${ADIColors.gray6};
            border: none;
        `
    },
    footerButtonWrapper: {
        css: css`
        display: flex;
        gap: 15px;
        justify-content: left;
        width: 120px;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`                
                    width: 95px;
                `,
                    css`                
                    width: 95px;
                `,
                    null,
                    null,
                    null,
                ])}
        `

    },
    button: {
        css: css`
            width: 200px;
            
        `,
    },
    cancelButton: {
        css: css`
            width: 200px;
            > span{
                color: ${ADIColors.blue5}
            }
            
        `,
    },
    cardExpired: {
        css: css`
            font-weight: bold;
        `
    },




    centeringWrapper: {
        css: css`
            height: 150px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    container: {
        css: css`
            display: flex;
            padding: 2px;
            border-radius: 6px;
            border: solid 1px ${ADIColors.gray2};
            background: ${ADIColors.white};
            max-width: 400px;
        `,
    },

    noDataFound: {
        css: css`
        margin-top: 36px;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.3;
        letter-spacing: normal;
        text-align: center;
        color: ${ADIColors.gray4};
        display: block;
        `
    },
    newCard: {
        css: css`
        margin-top: 30px;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
            color: ${ADIColors.gray4};
            display: block;
`
    },

    creditCardHeaderContainer: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
            background: ${ADIColors.white2};
            font-size: 16px;
            font-weight: bold;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    padding: 10px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                `,
                    css`
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding: 10px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                `,
                    css`
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding: 10px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                `,
                ])}
        `,
    },
    creditCardDataContainer: {
        css: css`
            padding: 10px;
            display: flex;
            flex-direction: row;
            width: 100%;
            align-items: center;
            &:nth-child(even) {
                background-color: ${ADIColors.white}!important;
            }
            &:nth-child(odd) {
                background-color: ${ADIColors.white2};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    selectColumn: {
        css: css`
            width: 80px;
        `,
    },
    cardDetailsColumn: {
        css: css`
            width: 25%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    width: 25%;
                `,
                    css`
                    width: 25%;
                `,
                    css`
                    width: 25%;
                `,
                ])}
        `,
    },
    cardExpiryColumn: {
        css: css`
            display: flex;
            flex-direction: row;
            text-transform: capitalize;
            align-items: center;
            gap: 15px;
            width: calc(100% - 25% - 200px);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    editDeleteColumn: {
        css: css`
            width: 120px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    accountNumberColumn: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`                
                    width: 25%;
                `,
                    css`
                    width: 16%;
                `,
                    css`
                    width: 16%;
                `,
                ])}
        `,
    },
    bankAccountContainerForMobile: {
        css: css`
            display: flex;
            flex-direction: row;
            padding: 10px;
            &:nth-child(even) {
                background-color: ${ADIColors.white}!important;
            }
            &:nth-child(odd) {
                background-color: ${ADIColors.white2};
            }
        `
    },
    selectColumnForMobile: {
        css: css`
            padding: 0px;
        `
    },
    creditCardDataContainerForMobile: {
        css: css`
            display: flex;
            padding: 10px 0px;
            flex-direction: row;
            text-transform: capitalize;
        `
    },
    sectionWrapper: {
        css: css`
            padding: 2px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:nth-child(even) {
                background-color: ${ADIColors.white}!important;
            }
            &:nth-child(odd) {
                background-color: ${ADIColors.white2};
            }
        `
    }
};
const AddButton = styled.div`
    cursor: pointer;
    padding: 2px;
    margin: 5px;
    gap: 15px;
    position: relative;
    &:last-child::before {
        border-left: 3px solid ${ADIColors.white2};
        content: "";
        position: absolute;
        left: -13px;
        height: 30px;
            }
`;

const CardExpiredWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`
const EditDeleteTitleWrapper = styled.div`
    display: flex;
    gap: 30px;
`
const styles = tableStyles;

export const CreditCardListInvoiceRecap = (props: any) => {
    const [isMobile, setIsMobile] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const {showAddNewCard, openAddNewCard, cartState, selectedCCId, handleCardRadioChange, creditCardListRecap, isLoadingCreditCard, callApi, paymentTypes} = props;
    const [isFormError, setIsFromError] = useState(false);
    const [isNewCardOpen, setIsNewCardOpen] = useState(false);
    const [isApiError, setIsApiError] = useState(true);
    const [savedCard, setSavedCard] = useState<GetSavedCreditCardsModel | null>(null);
    const expirationMonths = cartState?.value && cartState.value?.paymentOptions?.expirationMonths;
    const expirationYears = cartState?.value && cartState.value?.paymentOptions?.expirationYears;

    const { value: cart } = cartState;
    const cardTypes = cart?.paymentOptions && cart.paymentOptions?.cardTypes;

    const initialNewCardErrorState = {
        selectedCardType: false,
        creditCardNumber: false,
        expMonth: false,
        expYear: false,
        securityCode: false,
        zipCode: false,
    };
    const [formError, setFormError] = useState(initialNewCardErrorState);
    const closeNewCard = () => {
        showAddNewCard();
        setFormError(initialNewCardErrorState);
        setIsNewCardOpen(false);
        setIsFromError(false);
        setIsApiError(false);
    };

    const getApi = async (page = 1, pageSize = 12) => {
        callApi();
    };


    // Get Card
    const [isDeleteCardOpen, setIsDeleteCardOpen] = useState(false);
    const [savedCardData, setSavedCardData] = useState<CreditCardDtoCollection | null>(null);
    const [isEditCardOpen, setIsEditCardOpen] = useState(false);

    const openEditCard = (card: CreditCardDtoCollection | null) => {
        setSavedCardData(card)
        setIsEditCardOpen(true);
    };
    const closeEditCard = () => {
        setIsDeleteCardOpen(false);
        setIsEditCardOpen(false);
    };
    const openDeleteCard = (card: CreditCardDtoCollection | null) => {
        setSavedCardData(card)
        setIsDeleteCardOpen(true);
    };
    const closeDeleteCard = () => {
        setIsDeleteCardOpen(false);
        setIsEditCardOpen(false);
    };

    const checkExpirationDate = (month: any, year: any) => {
        var d = new Date();
        month = parseInt(month);
        year = year.length == 2 ? parseInt(d.getFullYear().toString().substring(0, 2) + year) : year;
        if (year == d.getFullYear() && month < (d.getMonth() + 1)) {
            return false;
        }

        if (year < d.getFullYear()) {
            return false;
        }

        return true;
    }
    useEffect(() => {
        const onWindowResize = () => {
            if (window.innerWidth >= 768) {
                setIsMobile(false);
            } else {
                setIsMobile(true);
            }
        };
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        if (openAddNewCard) {
            setIsNewCardOpen(true);
        }
    }, [openAddNewCard])

    // Changes related to new Credit card modal ----- p21 Changes
    const handleNewCardDetails =(data: any) =>{
        let item:any = {
            id : data.ccid,
            cardNumber : data.ccNumber,
            cardType : data.ccType,
            expiryMonth : data.ccExpiryMonth,
            expiryYear : data.ccExpiryYear,
            cardCVC : data.ccCvc,
            cardToken : data.ccToken,

        };

    }

    return  <>

        {isMobile ? (
            <Hidden above="sm">
                 {/* Card decline message */}
                 {isFormError && (
                                    <div
                                    >
                                        <Typography
                                            as={"span"}
                                            style={{
                                                color: `${ADIColors.danger}`,
                                            }}
                                        >
                                            {translate("Credit Card Declined")}
                                        </Typography>
                                    </div>
                                )}
                {creditCardListRecap && creditCardListRecap?.length != 0 ?
                    (
                        <RadioGroup
                            name="creditCardPayment"
                            {...styles.radioListGroup}
                            value={selectedCCId}
                            onChangeHandler={handleCardRadioChange}
                        >
                            {creditCardListRecap.map((item: CreditCardDtoCollection, index: number) => {
                                let cardName = "";
                                if (item.cardType === "AMEX") {
                                    cardName = "American Express";
                                } else if (item.cardType === "Visa/Master") {
                                    cardName = "Visa/Master";
                                } else if (item.cardType === "Discover") {
                                    cardName = "Discover";
                                } else {
                                    cardName = "Unknown"
                                }
                                let cardNumber = item.cardNumber.slice(item.cardNumber.length - 4);
                                return <StyledWrapper key={`${item.cardNumber}_${index}`} {...styles.sectionWrapper}>
                                            <StyledWrapper {...styles.creditCardDataContainerForMobile}>
                                                <Radio value={item.cardToken} disabled={!checkExpirationDate(item.expiryMonth, item.expiryYear)}></Radio>
                                                <StyledWrapper {...styles.selectColumnForMobile}>
                                                    <StyledWrapper>{cardName} ****{cardNumber}</StyledWrapper>
                                                    <StyledWrapper>Exp. Date:{item.expiryMonth}/{item.expiryYear}</StyledWrapper>
                                                    <StyledWrapper>{checkExpirationDate(item.expiryMonth, item.expiryYear) ? "":<CardExpiredWrapper> <Icon src={NpWarning}/><Typography {...styles.cardExpired}>{translate("This card has expired")}</Typography></CardExpiredWrapper>}</StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.footerButtonWrapper}>
                                                    <AddButton onClick={()=>openEditCard(item)}>
                                                        <Icon src="Edit" size={26} color={ADIColors.blue5} />
                                                    </AddButton>
                                                    <AddButton onClick={() => openDeleteCard(item)}>
                                                        <Icon src="Trash2" size={26} color={ADIColors.blue5} />
                                                    </AddButton>
                                                </StyledWrapper>
                                </StyledWrapper>
                            })}
                        </RadioGroup>
                    ) :
                    <Typography {...styles.noDataFound}>
                        There are no card currently. Please add a new card to get started.
                    </Typography>
                }
            </Hidden>
        ) : (
            <Hidden below="md">
                {isFormError && (
                                    <div
                                    >
                                        <Typography
                                            as={"span"}
                                            style={{
                                                color: `${ADIColors.danger}`,
                                            }}
                                        >
                                            {translate("Credit Card Declined")}
                                        </Typography>
                                    </div>
                                )}
                <StyledWrapper {...styles.creditCardHeaderContainer}>
                    <StyledWrapper {...styles.selectColumn}>{translate("Select")}</StyledWrapper>
                    <StyledWrapper {...styles.cardDetailsColumn}>{translate("Credit Card")}</StyledWrapper>
                    <StyledWrapper {...styles.cardExpiryColumn}>{translate("Expiration Date")}</StyledWrapper>
                    <StyledWrapper {...styles.editDeleteColumn}>
                        <EditDeleteTitleWrapper>
                            <StyledWrapper>{translate("Edit")}</StyledWrapper>
                            <StyledWrapper>{translate("Delete")}</StyledWrapper>
                        </EditDeleteTitleWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                {creditCardListRecap && creditCardListRecap?.length != 0 ? (
                    <RadioGroup
                        name="creditCardPayment"
                        {...styles.radioListGroup}
                        value={selectedCCId}
                        onChangeHandler={handleCardRadioChange}
                    >
                        {creditCardListRecap.map((item: CreditCardDtoCollection, index: number) => {
                            let cardName = "";
                            if (item.cardType === "AMEX") {
                                cardName = "American Express";
                            } else if (item.cardType === "Visa/Master") {
                                cardName = "Visa/Master";
                            } else if (item.cardType === "Discover") {
                                cardName = "Discover";
                            } else {
                                cardName = ""
                            }
                            let cardNumber = item.cardNumber.slice(item.cardNumber.length - 4);
                            return <StyledWrapper key={`${item.cardNumber}_${index}`} {...styles.creditCardDataContainer}>
                                <StyledWrapper {...styles.selectColumn}><Radio value={item.cardToken} disabled={!checkExpirationDate(item.expiryMonth, item.expiryYear)}></Radio></StyledWrapper>
                                <StyledWrapper {...styles.cardDetailsColumn}>{cardName} ****{cardNumber}</StyledWrapper>
                                <StyledWrapper {...styles.cardExpiryColumn}>
                                    <StyledWrapper>
                                        {item.expiryMonth}/{item.expiryYear}
                                    </StyledWrapper>
                                    {checkExpirationDate(item.expiryMonth, item.expiryYear) ? "" : <CardExpiredWrapper> <Icon src={NpWarning} /><Typography {...styles.cardExpired}>{translate("This card has expired")}</Typography></CardExpiredWrapper>}
                                </StyledWrapper>
                                <StyledWrapper {...styles.footerButtonWrapper}>
                                    <AddButton onClick={() => openEditCard(item)}>
                                        <Icon src="Edit" size={26} color={ADIColors.blue5} />
                                    </AddButton>
                                    <AddButton onClick={() => openDeleteCard(item)}>
                                        <Icon src="Trash2" size={26} color={ADIColors.blue5} />
                                    </AddButton>
                                </StyledWrapper>
                            </StyledWrapper>
                        })}
                    </RadioGroup>
                ) : (
                    <>
                        <Typography {...styles.noDataFound}>
                            There are no credit cards currently on the file.
                        </Typography>
                        <Typography {...styles.newCard}>
                            Please add a new card to get started.
                        </Typography>
                    </>
                )}
            </Hidden>
        )}



        {savedCardData && (<>
            <ADIEditCreditCardModalRecap
                savedCardData={savedCardData}
                isEditCardOpen={isEditCardOpen}
                closeEditCard={closeEditCard}
                getApi={getApi}
                expirationMonths={expirationMonths}
                expirationYears={expirationYears}
            />
            <ADIDeleteCreditCardModalRecap
                savedCardData={savedCardData}
                isDeleteCardOpen={isDeleteCardOpen}
                closeDeleteCard={closeDeleteCard}
                getApi={getApi}
            />
        </>
        )}

        {/* New Card */}
       <ADINewCreditCardModalPopup
            setFormError={setFormError}
            setIsFromError={setIsFromError}
            initialNewCardErrorState={initialNewCardErrorState}
            closeNewCard={closeNewCard}
            getApi={getApi}
            setIsApiError={setIsApiError}
            isNewCardOpen={isNewCardOpen}
            isFormError={isFormError}
            isApiError={isApiError}
            formError={formError}
            cardTypes={cardTypes}
            expirationMonths={expirationMonths}
            expirationYears={expirationYears}
            paginationModal={savedCard?.pagination}
            handleNewCardDetails={handleNewCardDetails}
            paymentTypes={paymentTypes}
            showSuccessCallback={() => { } }
            showErrorCallback={() => { } }       
            
            />
    </>
}